import * as React from 'react';
import { Stack, StackChildren, Text } from '@doordash/design-language';
import ContactSalesStrings from '../ContactSalesStrings';
var strings = ContactSalesStrings.thankYouDisplay;
export var ThankYouDisplay = function () {
    return (React.createElement(StackChildren, { size: Stack.Sizes.XxxSmall },
        React.createElement(Text, { styles: Text.Styles.PageTitle2 }, strings.title()),
        React.createElement(Text, { styles: Text.Styles.Label2 }, strings.body())));
};
export default ThankYouDisplay;
